import React, { useCallback } from 'react'
import { hooks, I18n } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Grid } from '@mui/material'

import Callbacks from './callbacks'
import GroupTab from '@abra/panels/Tab/Group'
import Form from './Form'
import Header from './Header'
import Row from './Row'

const LicenseList = props => {
  const { group_id } = hooks.useParams()
  const filterToForm = useCallback(Callbacks.filterToFormHandler(), [])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(group_id), [group_id])
  const formToOptions = useCallback(Callbacks.formToOptionsHandler(), [])
  return (
    <Box sx={{ p: 2 }}>
      <Grid container justifyContent='center' alignItems='center'>
        <Grid size={11}>
          <GroupTab value={2} />
        </Grid>
        <Grid size={11}>
          <SearchFrame
            model_name='license'
            populate={['usual_vehicle.group', 'usual_vehicle.info', 'billing_category']}
            createButtonProps={{ label: I18n.t('contract.add') }}
          >
            <SearchForm
              submitOnMount
              filterToForm={filterToForm}
              formToFilter={formToFilter}
              formToOptions={formToOptions}
            >
              <FormContent><Form /></FormContent>
            </SearchForm>
            <SearchTable>
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame>
        </Grid>
      </Grid>
    </Box >
  );
}

export default React.memo(LicenseList)
